<script>
// node_modules
import moment from 'moment-jalaali';
// components
import MultitabPicker from '~/components/common/multitab-picker';
// utils
import { TOUR_DATE_EVENTS } from '~endpoints';

export default {
    extends: MultitabPicker,

    props: {
        originId: {
            type: String,
            default: '',
        },
        destinationId: {
            type: String,
            default: '',
        },
    },

    data () {
        return {
            fetchedEvents: null,
            showSearch: false,
        };
    },

    computed: {
        tabs () {
            return [this.$t('highTrafficDates')];
        },
        options () {
            const options = (this.fetchedEvents || []);
            return options.map(el => ({
                title: el.title,
                // subtitle: `${this.date(el.from)} - ${this.date(el.to)}`,
                from: el.from,
                to: el.to,
                id: el.id,
            }));
        },
    },

    watch: {
        destinationId (t) {
            t && this.fetchCities();
        },
    },

    mounted () {
        const { originId, destinationId } = this;
        originId && destinationId && this.fetchCities();
    },

    methods: {
        date (x) {
            try {
                return moment(x, 'jYYYY-jMM-jDD').format('jDD jMMMM');
            } catch (e) {}
            return x;
        },

        onSelect (option) {
            if (!option || option.disabled) return;
            this.$emit('input', option);
            this.$emit('set-tour-search-date', option);
            this.$emit('done');
            this.hoveredIndex = this.options.indexOf(option);
            this.$device.desktop ? this.$refs.dropdown.close() : this.showModal = false;
        },

        fetchCities () {
            this.loading = true;
            return this.$axios.$post(TOUR_DATE_EVENTS, {
                originKey: this.originId,
                destinationKey: this.destinationId,
            }).then(({ result }) => {
                this.fetchedEvents = result;
                if (this.$route.query) {
                    const { from, to } = this.$route.query;
                    let eventIndex = 0;
                    const found = result.find((event, index) => {
                        if (from === this.$moment.autoParse(event.from).format('YYYY-MM-DD') && to === this.$moment.autoParse(event.to).format('YYYY-MM-DD')) {
                            eventIndex = index;
                            return true;
                        }
                        return false;
                    });
                    if (found) {
                        this.inputValue = found.title;
                        this.hoveredIndex = eventIndex;
                        this.$emit('input', found);
                    }
                    found && this.$emit('set-selected-date', found);
                }
            }).catch(err => {
                this.fetchedEvents = null;
                console.error(err); // eslint-disable-line no-console
            }).finally(() => {
                this.loading = false;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.multitab-picker {

    &__dropdown {
        width: 280px;
        @media (max-width: 767px) {
            width: 100%;
        }
    }

    &__tabs {

        > li {
            margin-bottom: 1px;
        }
    }
}
</style>

<i18n>
{
    "fa": {
        "highTrafficDates": "تاریخ‌های پر تردد"
    }
}
</i18n>
